import {Fragment, useEffect, useState, useContext} from 'react';

import classes from './BinuyShikun.module.scss';
import LoginContext from '../../../../../store/login-context';
import BackStep from '../General/BackStep/BackStep';
import Skip from '../Skip/Skip';
import ProgressBar from '../ProgressBar/ProgressBar';



declare function Translate(key: string): string;
declare var _curLang: any;

const BinuyShikun = (props) => {
    const ctx = useContext(LoginContext);

    useEffect(() => {                        
        if(ctx.summaryRegOptions.length > 2){
            const regOptions = ctx.summaryRegOptions.slice();
            ctx.updateSummaryRegOptions([regOptions[0],regOptions[1]]);
        }
    },[]);

    const handleYesClick = () => {
        ctx.updateSummaryRegOptions([...ctx.summaryRegOptions, "binuyShikun"]);
        props.setCurrentScreenStep(ctx.preRegScreenCollection.summaryOptions);
        props.AddUserStep(ctx.preRegScreenCollection.summaryOptions);
    };

    const handleNoClick = () => {
        // ctx.updateSummaryRegOptions([]);
        props.setCurrentScreenStep(ctx.preRegScreenCollection.bioIdFirst);
        props.AddUserStep(ctx.preRegScreenCollection.bioIdFirst);
    };
   
    const onBackStepHandler = () => {
        props.prevScreen(); 
    }
        
    return(
        <Fragment>
             <ProgressBar pbWidth="68%"/>
            <div className={classes.container}>
                <div>
                <BackStep prevStep = {onBackStepHandler} />
            
                <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_SignUp_Shikun')}</div>
               
                <div className={classes.buttons_container}>
                    <button className={`${classes.btn_no} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_ltr : ''}`} id='btnShikunNo' onClick={handleNoClick}>
                        <span>{Translate('N_General_No')}</span>                     
                    </button>
                    <button className={classes.btn_yes} id='btnShikunYes' onClick={handleYesClick}>
                        <span>{Translate('N_General_Yes')}</span>                     
                    </button>
                </div>
                <div className={classes.buttons_container_mobile}>
                    <button className={classes.btn_yes} id='btnShikunYesMobile' onClick={handleYesClick}>
                        <span>{Translate('N_General_Yes')}</span>                     
                    </button>
                    <button className={`${classes.btn_no} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_ltr : ''}`} id='btnShikunNoMobile' onClick={handleNoClick}>
                        <span>{Translate('N_General_No')}</span>                     
                    </button>
                </div>
                </div>
                <div className={classes.skip}>
                    <Skip/>
                </div>
            </div>          
        </Fragment>
    )
};
export default BinuyShikun ;